import React from "react";
import { Outlet, useLoaderData } from "react-router";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import { getEndCustomerPaidByID } from "../../../../API/swesum";
export async function loader({ params }) {
  const endcustomerPaid = await getEndCustomerPaidByID(params.paidID);
  return { endcustomerPaid };
}

export function EndCustomerPaidPage() {
  const { endcustomerPaid } = useLoaderData();
  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={15} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} md={12}>
            <Outlet />
          </Grid>
          {/* <Grid item xs={12}>
            <PaidInvoiceWorkflow
              payedInvoiceId={endcustomerPaid.EndCustomerPayedInvoiceId}
            />
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  );
}
